const appConfig = {
    apiPrefix: 'https://ttcg-aftersales.directaffinitycx.net/api/v1',
    authenticatedEntryPath: '/',
    unAuthenticatedEntryPath: '/',
    enableMock: false
}

export default appConfig